export enum ScheduleDisplayMode {
  ADVANCED = 'ADVANCED',
  BASIC_DAILY = 'BASIC_DAILY',
  BASIC_MONTHLY = 'BASIC_MONTHLY'
}
